import { types } from '../types/typesContacts';
import { fetchConToken } from '../../helpers/fetch';

export const iniGetListAllContacts = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('contacts');
            const body = await resp.json();
            if (body.ok) {
                dispatch(contactsGetAllContacts(body.data));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniGetListCustomers = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('contacts/clas/customers');
            const body = await resp.json();
            if (body.ok) {
                dispatch(contactsGetListCustomers(body.data))
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniGetListSuppliers = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('contacts/clas/suppliers');
            const body = await resp.json();
            if (body.ok) {
                dispatch(contactsGetListSuppliers(body.data));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniGetListExecutives = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('contacts/executives');
            const body = await resp.json();
            if (body.ok) {
                dispatch(contactsGetListExecutives(body.data));
            }
        } catch (error) {
            console.log(error);
        }
    }
}

export const iniGetListPersonas = () => {
    return async (dispatch) => {
        try {
            const resp = await fetchConToken('contacts/clas/personas');
            const body = await resp.json();
            if (body.ok) {
                dispatch(contactsGetListPersonas(body.data));
            }
        } catch (error) {
            console.log(error);
        }
    }
}


// export const iniAddNewContact = (newContact) => {
//     return async (dispatch) => {
//         try {
//             const resp = await fetchConToken('contacts', newContact, 'POST');
//             const body = await resp.json();
//             if (body.ok) {
//                 toast.success(body.msg);
//                 if (newContact.clasificacion === 'proveedor') {
//                     dispatch(contactsAddNewSupplier(body.data));
//                     dispatch(comprasSetNewProveedor(body.data.id));
//                 } else {
//                     dispatch(contactsAddNewCustomer(body.data));
//                 }
//             }
//         } catch (error) {
//             console.log(error);
//         }
//     }
// }

const contactsGetAllContacts = (contacts) => ({
    type: types.contactsGetAllContacts,
    payload: contacts
})

const contactsGetListCustomers = (contacts) => ({
    type: types.contactsGetListCustomers,
    payload: contacts
})

const contactsGetListSuppliers = (contacts) => ({
    type: types.contactsGetListSuppliers,
    payload: contacts
})

const contactsGetListExecutives = (contacts) => ({
    type: types.contactsGetListExecutives,
    payload: contacts
})

const contactsGetListPersonas = (contacts) => ({
    type: types.contactsGetListPersonas,
    payload: contacts
})

export const contactsAddNewSupplier = (contacts) => ({
    type: types.contactsAddNewSupplier,
    payload: contacts
})

export const contactsAddNewCustomer = (contacts) => ({
    type: types.contactsAddNewCustomer,
    payload: contacts
})